module.exports = __webpack_public_path__ + "static/media/minimize.483571e5.svg";